import React, { useState, useEffect } from 'react';
import { Calendar as BigCalendar, momentLocalizer } from 'react-big-calendar';
import moment from 'moment';
import 'react-big-calendar/lib/css/react-big-calendar.css';
import Modal from 'react-modal';
import { useDispatch, useSelector } from 'react-redux';
import { newAgenda, getAgenda, delAgenda } from '../../redux/actions';
import styles from './Calendar.module.css';
import { FaTrash } from 'react-icons/fa';
import Swal from 'sweetalert2';  // Importar SweetAlert2

moment.locale('es');
const localizer = momentLocalizer(moment);

const Calendar = () => {
    const dispatch = useDispatch();
    const usuario = useSelector(state => state.usuario);
    const agendas = useSelector(state => state.agenda);
    // console.log("AGENDA::", agendas)

    const [events, setEvents] = useState([]);
    const [modalIsOpen, setModalIsOpen] = useState(false);
    const [selectedDate, setSelectedDate] = useState(null);
    const [startTime, setStartTime] = useState('');
    const [endTime, setEndTime] = useState('');
    const [selectedLugar, setSelectedLugar] = useState('');
    const [error, setError] = useState('');
    const [cancelConfirmation, setCancelConfirmation] = useState(false);
    const [cancelingEventId, setCancelingEventId] = useState(null);
    const [cancelSuccessMessage, setCancelSuccessMessage] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);


    const [auxiliar, setAuxiliar] = useState(false);
    const [videoBeams, setVideoBeams] = useState(false);
    const [extensiones, setExtensiones] = useState(false);
    const [otro, setOtro] = useState('');

    useEffect(() => {
        dispatch(getAgenda());
    }, [dispatch]);

    useEffect(() => {
        const mappedEvents = agendas
            // .filter(agenda => agenda.aprobado === 1)
            .map(agenda => ({
                id: agenda.id,
                start: new Date(agenda.horaini),
                end: new Date(agenda.horafin),
                title: `Lugar: ${agenda.lugar}  Responsable: ${agenda.Usuario.nombre}`,
                UsuarioId: agenda.UsuarioId,
            }));
        setEvents(mappedEvents);
    }, [agendas]);

    const handleSelectSlot = ({ start }) => {
        setSelectedDate(start);
        setModalIsOpen(true);
        setError('');
    };

    const isPastDate = (date) => {
        return moment(date).startOf('day').isBefore(moment().startOf('day'));
    };

    const handleAddEvent = () => {
        if (isPastDate(selectedDate)) {
            setError('No se pueden agendar salas en fechas pasadas.');
            return;
        }

        if (!selectedLugar || !startTime || !endTime) {
            setError('Faltan datos para poder agendar. Por favor, complete todos los campos.');
            return;
        }

        const start = new Date(selectedDate);
        start.setHours(startTime.split(':')[0], startTime.split(':')[1]);

        const end = new Date(selectedDate);
        end.setHours(endTime.split(':')[0], endTime.split(':')[1]);

        // Validación adicional por si acaso cambian la hora a una pasada en el día de hoy
        if (moment(start).isBefore(moment())) {
            setError('No se puede agendar en una hora que ya pasó.');
            return;
        }

        if (start.getHours() < 6 || end.getHours() > 20 || end <= start) {
            setError('Las horas deben estar entre 6:00 am y 8:00 pm, y la hora de fin debe ser posterior a la hora de inicio.');
            return;
        }

        const overlappingEvent = events.find(event =>
            event.title.includes(`Lugar: ${selectedLugar}`) && (
                (start >= event.start && start < event.end) ||
                (end > event.start && end <= event.end) ||
                (start <= event.start && end >= event.end)
            )
        );

        if (overlappingEvent) {
            setError('Ya hay una agenda en las horas seleccionadas para el lugar seleccionado. Por favor, escoja una nueva hora.');
            return;
        }

        const newEvent = {
            horaini: start.toISOString(),
            horafin: end.toISOString(),
            lugar: selectedLugar,
            UsuarioId: usuario.usuario.id,
            nombreUsuario: usuario.usuario.nombre,
            correoUsuario: usuario.usuario.email,
            auxiliar,
            videoBeams,
            extensiones,
            otro,
        };
        setIsSubmitting(true); // 🔐 Bloquea el botón

        dispatch(newAgenda(newEvent)).then(() => {
            dispatch(getAgenda()); // vuelve a cargar las agendas ya filtradas
            setModalIsOpen(false);
            Swal.fire('Evento Agendado', 'Se ha programado su evento con exito.', 'success');  // Alert de éxito
        }).catch(error => {
            console.error('Error al agregar agenda:', error);
            Swal.fire('Error', 'Hubo un problema al agregar la agenda.', 'error');  // Alert de error
        }).finally(() => {
            setIsSubmitting(false); // 🔓 Desbloquea el botón al final
        });

    };

    const handleCancelConfirmation = (event) => {
        const today = moment().startOf('day');
        const eventDate = moment(event.start).startOf('day');

        if (eventDate.isBefore(today)) {
            return; // Silently prevent deletion of past events
        }

        Swal.fire({
            title: '¿Estás seguro de que deseas cancelar este evento?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Sí, cancelar',
            cancelButtonText: 'No, mantener',
        }).then((result) => {
            if (result.isConfirmed) {
                dispatch(delAgenda(event.id)).then(() => {
                    setEvents(events.filter(e => e.id !== event.id));
                    Swal.fire('Cancelado', 'El evento ha sido cancelado con éxito.', 'success');
                }).catch(error => {
                    console.error('Error al cancelar evento:', error);
                    Swal.fire('Error', 'Hubo un problema al cancelar el evento.', 'error');
                });
            }
        });
    };

    const handleCancelEvent = () => {
        dispatch(delAgenda(cancelingEventId)).then(() => {
            setEvents(events.filter(event => event.id !== cancelingEventId));
            setCancelConfirmation(false);
            setCancelSuccessMessage('Cancelado con éxito');
            setTimeout(() => {
                setCancelSuccessMessage('');
            }, 3000);
        }).catch(error => {
            console.error('Error al cancelar evento:', error);
            setCancelConfirmation(false);
            alert('Hubo un error al intentar cancelar el evento.');
        });
    };

    const getEventsForSelectedDate = () => {
        return events.filter(
            event =>
                moment(event.start).isSame(selectedDate, 'day') &&
                moment(event.end).isSame(selectedDate, 'day')
        );
    };

    return (
        <div className={styles.calendarContainer}>
            <BigCalendar
                localizer={localizer}
                events={events}
                startAccessor="start"
                endAccessor="end"
                selectable
                onSelectSlot={handleSelectSlot}
                style={{ height: 600 }}
                views={['month']}
                messages={{
                    next: "Sig",
                    previous: "Ant",
                    today: "Hoy",
                    month: "Mes",
                    week: "Semana",
                    day: "Día"
                }}
            />
            <Modal
                isOpen={modalIsOpen}
                onRequestClose={() => setModalIsOpen(false)}
                style={{
                    content: {
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        right: 'auto',
                        bottom: 'auto',
                        marginRight: '-50%',
                        transform: 'translate(-50%, -50%)',
                        backgroundColor: '#fff',
                        padding: '32px',
                        borderRadius: '24px',
                        outline: 'none',
                        width: '800px',
                        maxWidth: '95%',
                        boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.25)',
                        maxHeight: '90vh',
                        overflowY: 'auto',
                        border: 'none'
                    },
                    overlay: {
                        backgroundColor: 'rgba(15, 23, 42, 0.75)',
                        backdropFilter: 'blur(4px)',
                        zIndex: 1000,
                    },
                }}
                contentLabel="Seleccionar Rango de Horas"
            >
                <h2 className={styles.modalTitle}>
                    Agendar para el {selectedDate && moment(selectedDate).format('DD [de] MMMM')}
                </h2>

                <div className={styles.modalContent}>
                    <div className={styles.column}>
                        <div className={styles.inputGroup}>
                            <label className={styles.inputLabel}>Hora de inicio</label>
                            <input
                                type="time"
                                className={styles.input}
                                value={startTime}
                                onChange={(e) => setStartTime(e.target.value)}
                            />
                        </div>
                        <div className={styles.inputGroup}>
                            <label className={styles.inputLabel}>Hora de fin</label>
                            <input
                                type="time"
                                className={styles.input}
                                value={endTime}
                                onChange={(e) => setEndTime(e.target.value)}
                            />
                        </div>
                        <div className={styles.inputGroup}>
                            <label className={styles.inputLabel}>Lugar / Sala</label>
                            <select
                                className={styles.select}
                                value={selectedLugar}
                                onChange={(e) => setSelectedLugar(e.target.value)}
                            >
                                <option value="">Seleccione un lugar</option>
                                <option value="Sala Juntas">Sala de Juntas</option>
                                <option value="Sala Capacitación">Sala de Capacitación</option>
                                <option value="Cafeteria">Cafetería</option>
                            </select>
                        </div>
                    </div>

                    <div className={styles.column}>
                        <label className={styles.inputLabel}>Recursos adicionales</label>
                        <div className={styles.checkboxCard}>
                            <label className={styles.checkboxLabel}>
                                <input
                                    type="checkbox"
                                    checked={auxiliar}
                                    onChange={(e) => setAuxiliar(e.target.checked)}
                                />
                                Auxiliar cafetería
                            </label>
                            <label className={styles.checkboxLabel}>
                                <input
                                    type="checkbox"
                                    checked={videoBeams}
                                    onChange={(e) => setVideoBeams(e.target.checked)}
                                />
                                Televisor / VideoBeam
                            </label>
                            <label className={styles.checkboxLabel}>
                                <input
                                    type="checkbox"
                                    checked={extensiones}
                                    onChange={(e) => setExtensiones(e.target.checked)}
                                />
                                Extensiones eléctricas
                            </label>
                            <input
                                type="text"
                                className={`${styles.input} ${styles.otroInput}`}
                                value={otro}
                                onChange={(e) => setOtro(e.target.value)}
                                placeholder="Especifique otro recurso..."
                            />
                        </div>
                    </div>
                </div>

                {error && <div className="alert alert-danger" style={{ marginBottom: '20px' }}>{error}</div>}

                <button
                    className={styles.submitBtn}
                    onClick={handleAddEvent}
                    disabled={isSubmitting || isPastDate(selectedDate)}
                    style={isPastDate(selectedDate) ? { opacity: 0.5, cursor: 'not-allowed', filter: 'grayscale(1)' } : {}}
                >
                    {isPastDate(selectedDate) ? 'Consulta (Histórico)' : isSubmitting ? 'Procesando...' : 'Confirmar Reserva'}
                </button>

                <div className={styles.eventsSection}>
                    <h3>Reservas para este día</h3>
                    <div className={styles.eventsList}>
                        {getEventsForSelectedDate().length === 0 ? (
                            <p style={{ color: '#94a3b8', fontSize: '0.9rem', textAlign: 'center' }}>No hay reservas programadas.</p>
                        ) : (
                            getEventsForSelectedDate().map(event => (
                                <div key={event.id} className={styles.eventItem}>
                                    <div className={styles.eventInfo}>
                                        <span className={styles.eventBadge}>
                                            {moment(event.start).format('HH:mm')} - {moment(event.end).format('HH:mm')}
                                        </span>
                                        <strong>{event.title.split('  ')[0].replace('Lugar: ', '')}</strong>
                                        <span style={{ color: '#64748b' }}>
                                            {event.title.split('  ')[1].replace('Responsable: ', '')}
                                        </span>
                                    </div>
                                    {event.UsuarioId === usuario.usuario.id && !isPastDate(event.start) && (
                                        <FaTrash
                                            onClick={() => handleCancelConfirmation(event)}
                                            className={styles.deleteIcon}
                                        />
                                    )}
                                </div>
                            ))
                        )}
                    </div>
                </div>

                {cancelSuccessMessage && (
                    <div className="alert alert-success" style={{ marginTop: '20px' }}>
                        {cancelSuccessMessage}
                    </div>
                )}
            </Modal>
        </div>
    );
};

export default Calendar;
